import React from "react";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class ChangeStatus extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { message: '', newstatus: 3 };
  }
  update = (ev) => {
    this.setState({ message: ev.target.value });
  }
  handleClose = () => {
    this.props.onClose();
  }
  approve = () => {
    this.props.onChange(3, this.state.message)
  }
  reject = () => {
    this.props.onChange(2, this.state.message)
  }
  render() {
    return (
      <div>
        <Dialog
          fullScreen
          open={true}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Aanpassen status werkbon</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pas hier de status aan voor deze werkbon. Mocht deze worden afgekeurd, dan wordt dit gemeld bij de eigenaar en kan de werkbon worden aangepast. Bij goedkeuring zal de werkbon worden afgerond en kan worden doorgestuurd naar de administratie.
            </DialogContentText>
            <TextField
              multiline
              autoFocus
              margin="dense"
              id="remark"
              label=" Opmerking voor de nieuwe status"
              type="text"
              value={this.state.message}
              onChange={this.update}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              Annuleren
            </Button>
            <Button onClick={this.reject} disabled={this.state.message.length === 0}>
              Afkeuren
            </Button>
            <Button variant="contained" onClick={this.approve} color="primary" >
              Goedkeuren
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default ChangeStatus;
